import type { ButtonGroupSizes } from './types';

export const buttonGroupIconSizeMap: Record<ButtonGroupSizes, number> = {
  xs: 12,
  sm: 18,
  md: 20,
};
